import { gql } from '@apollo/client'
import { DISPLAY_FRAGMENT } from './DisplayFragment'
import { STORE_ADDRESS_FRAGMENT } from './StoreAddressFragment'

export const FULL_STORE_FRAGMENT = gql`
  fragment FullStore on CompanyStore {
    id
    name
    isActive
    distance
    daysSinceAudit
    category
    physicalStoreId
    internalStoreId
    hasAllFormulas
    image {
      url
      id
    }
    address {
      ...StoreAddress
    }
    point {
      latitude
      longitude
    }
    storeMap {
      id
      geoJson
    }
    storeChain
    displays {
      ...Display
    }
  }
  ${DISPLAY_FRAGMENT}
  ${STORE_ADDRESS_FRAGMENT}
`
